// @ts-nocheck
/* eslint-disable */
import React, { PureComponent } from 'react';
import { css } from '@emotion/css';
import { theme } from '@branchjs/neo-components';
import SelectionListItem from './SelectionListItem';

const selectionListStyles = {
  container: css({
    backgroundColor: theme.colors.gray[0],
    maxHeight: 345,
    overflow: 'scroll',
    marginTop: 5,
    padding: '5px 0px',
    borderRadius: 5,
    border: `1px solid ${theme.colors.gray.neutral}`,
  }),
};

class SelectionList extends PureComponent {
  render() {
    const { selections, onRemoveSelection, secondaryLabelKey, statusLabelType } = this.props;
    const { container } = selectionListStyles;
    return (
      <div className={selections.length ? container : undefined}>
        {selections.map((selection, index) => {
          return (
            <SelectionListItem
              key={index}
              selection={selection}
              onRemoveSelection={onRemoveSelection}
              secondaryLabelKey={secondaryLabelKey}
              statusLabelType={statusLabelType}
            />
          );
        })}
      </div>
    );
  }
}

export default SelectionList;
